import $ from 'jquery'
import objectFitImages from 'object-fit-images'

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.$ = window.jQuery = $
// require('foundation-sites')

require('./lib/foundation-explicit-pieces')

$(document).foundation()

$('html').removeClass('no-js')

// TODO: Delete this file later
// together with breakpoint.html -- page and layout
require('./lib/temporary')

require('./lib/menu')
require('./lib/carousels')
require('./lib/gsap-fade')
require('./lib/gsap-lottie')
require('./lib/videos')
require('./lib/equalize')
require('./lib/team-leadership')
require('./lib/story')
require('./lib/categories')
require('./lib/department')
require('./lib/duplicate-petals')
require('./lib/lightboxes')
require('./lib/solutions-tech')
require('./lib/process')
require('./lib/verticals')
require('./lib/solutions')
require('./lib/city-tabs')
require('./lib/story-timer')
require('./lib/stickyApplyButton')
require('./lib/open-positions')
require('./lib/home-page-carousel')
require('./lib/reviews')
require('./lib/filters')

objectFitImages($('.js-image-fit img'))
